import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Product } from '../../models/product.model';
import { ProductService } from '../../services/product.service';
import { CartService } from '../../services/cart.service';
import { AddToCartRequest, CartItemDto } from '../../models/add-to-cart-request.model';
import { DomSanitizer } from '@angular/platform-browser';
import { ToastService } from '../../toast.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-product-detail',
  templateUrl: './product-detail.component.html',
  styleUrl: './product-detail.component.css'
})
export class ProductDetailComponent implements OnInit {
  product!: Product;
  quantity: number = 1;
  specificationHtml: any = '';
  selectedSize: string = '';
  sizes: string[] = ['M', 'L', 'XL', 'XXL'];
  environment = environment;

  sizeChart = [
    { size: 'M', chest: 39, length: 27.5, sleeve: 8.5 },
    { size: 'L', chest: 40.5, length: 28, sleeve: 8.75 }
  ];


  constructor(
    private route: ActivatedRoute,
    private productService: ProductService,
    private cartService: CartService,
    private sanitizer: DomSanitizer,
    private toast: ToastService
  ) { }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      const id = Number(params.get('id'));
      if (id) {
        this.productService.getProductById(id).subscribe({
          next: (data) => {
            this.product = data;
            this.sizes = JSON.parse(JSON.parse(data.size.toString())[0])
            this.sizeChart = JSON.parse(JSON.parse(data.sizeChart.toString())[0])
            this.specificationHtml = this.sanitizer.bypassSecurityTrustHtml(data.specification)
          },
          error: (err) => {
            //console.error('Error loading product:', err);
            this.toast.show('Error loading product:', 'error');
          }
        });
      }
    });
  }

  addToCart(): void {
    const userId = localStorage.getItem('userId');
    if (!userId) {
      this.toast.show('User not logged in. Please login first.', 'error');
      return;
    }

    if (this.selectedSize != '') {
      const cartItem: CartItemDto = {
        productId: this.product.id,
        quantity: this.quantity,
        price: this.product.price,
        size: this.selectedSize
      };

      const cart: AddToCartRequest = {
        userId: userId,
        items: [cartItem]
      };

      this.cartService.addToCart(cart).subscribe({
        next: (response) => {
          this.toast.show(response.message, 'success');
          this.cartService.refreshCartCount(); // refresh count after successful add
        },
        error: (err) => {
          console.error('Error creating product:', err)
          this.toast.show(err.error?.message || 'Something went wrong', 'error');
        }
      });
    }
    else {
      this.toast.show('Please select size before add to cart!', 'success');
      return;
    }
  }

  selectSize(size: string) {
    this.selectedSize = size;
  }

  increaseQuantity() {
    this.quantity++;
  }

  decreaseQuantity() {
    if (this.quantity > 1) this.quantity--;
  }
}
